// @core/api/endpoints/userprofile/activate_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateUserprofileRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Activate user profile
 * Activates a profile, making it visible and usable. Inactive profiles are hidden from searches and cannot perform actions.
 */
export async function ActivateUserprofile(
  profile_id: string,
  data: ActivateUserprofileRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/activate`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
